import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';

import getInjectors from './reducerInjectors';

// Global store reference - will be set by app.js
let globalStore = null;

export function setStore(store) {
  globalStore = store;
  console.log('[injectReducer] Store initialized');
}

/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */
export default ({ key, reducer }) => WrappedComponent => {
  function ReducerInjector(props) {
    const injectorsRef = useRef(null);

    // Inject synchronously so reducers are available before child mounts
    if (!injectorsRef.current && globalStore) {
      injectorsRef.current = getInjectors(globalStore);
      const { injectReducer: inject } = injectorsRef.current;
      inject(key, reducer);
    }

    return <WrappedComponent {...props} />;
  }

  ReducerInjector.displayName = `withReducer(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;
  ReducerInjector.WrappedComponent = WrappedComponent;

  return hoistNonReactStatics(ReducerInjector, WrappedComponent);
};